<template>

    <div class="row parameters-container">

      <div class="col-4 parameter-container">
          <QueryNormalizedBox name="taxon_1" position="1" example="pangolins"/>
      </div>

      <div class="col-4 parameter-container">
          <QueryNormalizedBox name="taxon_2" position="2" example="cats"/>
      </div>

      <div class="col-4 parameter-container">
        <QueryNormalizedBox name="interaction" example="host"/>
      </div>

    </div>

</template>


<script>
import { mapState } from 'vuex'
import QueryNormalizedBox from '@/components/QueryNormalizedBox.vue'
let robi = require('../assets/js/robi.js');

    export default {
      name: 'QuerySimple',
      components: {
        QueryNormalizedBox
      },
      data() {
        return {
          robi_options: robi.sort((a, b) => a.term.localeCompare(b.term)),
            norm_taxon1: false,
            norm_taxon2: false,
            list_taxon1: null,
            list_taxon2: null,
            item_size: 6
        };
      },
      computed: {
        ...mapState(['user_query']),
      },
    }

</script> 


<style scoped lang="scss">

    .parameters-container {
        padding-bottom: 20px;
        text-align: left
    }

    label {
        width: 100%;
        font-weight: bold;
    }

    input {
      width: 100%;
      padding-left: 50px;
      background: url("~@/assets/images/icon_search.png") #fff no-repeat 2px 3px;
      background-size: 30px;
      height: 40px;
      border: 1px solid grey;
      border-radius: 5px;
      font-size: 1.2em;
   }


</style>
